export default __webpack_public_path__ + "static/media/openSansSemiBold.d7261533.ttf";